import { IdentifiedProfileResponse } from '../../../../api/DTO/IdentifiedProfileResponse';
import LinkedInCompanyIcon from '@/Components/TalentMeshIcons/LinkedInCompanyIcon';

type PersonalInfoCellProps = IdentifiedProfileResponse;

const PersonalInfoCell = ({ ...profileResponse }: PersonalInfoCellProps) => {
    const { profile } = profileResponse;

    return (
        <div className="flex w-full items-center gap-1">
            <a href={profile.url} target="_blank" rel="noreferrer" className="text-[#0A66C2] hover:opacity-80">
                <span className="size-6">
                    <LinkedInCompanyIcon />
                </span>
            </a>
        </div>
    );
};

export default PersonalInfoCell;
